var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNat21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.756,
    height: 80.358,
    viewBox: "0 0 71.756 80.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_622_12",
    "data-name": "Component 622 \\u2013 12",
    transform: "translate(1.75 2.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29796",
    "data-name": "Group 29796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M2977.927,2990.487h68.256v-16.746h-27.947l-6.447,9.365h-33.862",
    transform: "translate(-2977.927 -2914.353)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M3037.117,2841.77l-13.578,13.277-12.3-12.581,32.616-31.893,12.3,12.581-5.495,5.373",
    transform: "translate(-2999.454 -2808.902)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x1: 5.73,
    y1: 5.86,
    transform: "translate(52.83)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x1: 5.73,
    y1: 5.86,
    transform: "translate(9.923 41.957)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    y1: 6.083,
    x2: 6.221,
    transform: "translate(29.05 18.738)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M3128.327,2886.218c6.967,7.3,10.355,12.816,12.254,25.883",
    transform: "translate(-3075.126 -2857.789)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M3103.537,2910.121a24.031,24.031,0,0,1,1.678,17.427",
    transform: "translate(-3059.105 -2873.237)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x2: 9.456,
    transform: "translate(45.531 67.377)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_472",
    "data-name": "Ellipse 472",
    cx: 5.474,
    cy: 5.474,
    r: 5.474,
    transform: "translate(36.314 24.239) rotate(-31.718)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNat21);
export default __webpack_public_path__ + "static/media/nat2-1.f641a6901c99ca067805543b72209804.svg";
export { ForwardRef as ReactComponent };